module.exports = __webpack_public_path__ + "img/3x.d5b3bf1.jpg";